module.exports = __webpack_public_path__ + "static/img/WisdomSiteWuliao.814ec43.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteWuliao.png
// module id = /6tY
// module chunks = 12